import {CdkDrag, CdkDropList} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatRippleModule} from '@angular/material/core';
import {MatMenuModule} from '@angular/material/menu';
import {MatTreeModule} from '@angular/material/tree';
import {NbSecurityModule} from '@nebular/security';
import {
  NbActionsModule,
  NbAlertModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbProgressBarModule,
  NbRadioModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTagModule,
  NbToggleModule,
  NbTooltipModule
} from '@nebular/theme';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {FormlyModule} from '@ngx-formly/core';
import {TuiNotification} from '@taiga-ui/core';
import {TableModule} from 'compob2b-table';
import {FileUploadModule} from 'ng2-file-upload';
import {NgxPaginationModule} from 'ngx-pagination';
import {BreadcrumbsModule} from '../../../../../compob2b-customer/src/app/cabinet/breadcrumbs/breadcrumbs.module';
import {BaseModule} from '../../../../../compob2b-table/lib/components/base/base.module';
import {AdminSharedModule} from '../../admin-shared/admin-shared.module';
import {CatalogModule} from '../pim/catalog/catalog.module';
import {CreateUpdateDamComponent} from './create-update/create-update-dam.component';
import {DamExternalUploadComponent} from './dam-external-upload/dam-external-upload.component';
import {DamCatalogLazyComponent} from './dam-lazy-tree/dam-catalog-lazy.component';
import {CreateUpdateDamPersonComponent} from './dam-person/create-update-dam-collections/create-update-dam-person.component';
import {DamPersonListComponent} from './dam-person/list/dam-person-list.component';
import {DamRelatedCollectionTableComponent} from './dam-related-collection-table/dam-related-collection-table.component';
import {
  CreateUpdateDamRelatedCollectionComponent
} from './dam-related-collections/create-update-dam-collections/create-update-dam-related-collecton.component';
import {DamRelatedCollectionListComponent} from './dam-related-collections/list/dam-related-collection-list.component';
import {DamRoutingModule} from './dam-routing.module';
import {DamSearchModalComponent} from './dam-search-modal/dam-search-modal.component';
import {DamShareSearchElasticComponent} from './dam-share-search-elastic/dam-share-search-elastic.component';
import {DamShareComponent} from './dam-share/dam-share.component';
import {BasketInfoComponent} from './files/basket-info/basket-info.component';
import {BasketTableLogListComponent} from './files/basket-table-log/list/basket-table-log-list.component';
import {BasketTableComponent} from './files/basket-table/basket-table.component';
import {BasketListComponent} from './files/basket/basket-list.component';
import {DamContentComponent} from './files/dam-content/dam-content.component';

import {DamItemVersionsRenameComponent} from './files/dam-item-versions-rename/dam-item-versions-rename.component';
import {ShareDamItemVersionsComponent} from './files/share-dam-item-versions/share-dam-item-versions.component';
import {ShareDamItemComponent} from './files/share-dam-item/share-dam-item.component';
import {SecuredImageComponent} from './secured-image/secured-image.component';
import {YandexImportComponent} from './yandex-import/yandex-import.component';

@NgModule({
  declarations: [
    BasketInfoComponent,
    BasketListComponent,
    BasketTableComponent,
    BasketTableLogListComponent,
    CreateUpdateDamComponent,
    CreateUpdateDamPersonComponent,
    CreateUpdateDamRelatedCollectionComponent,
    DamCatalogLazyComponent,
    DamContentComponent,
    DamExternalUploadComponent,
    DamItemVersionsRenameComponent,
    DamPersonListComponent,
    DamRelatedCollectionListComponent,
    DamRelatedCollectionTableComponent,
    DamSearchModalComponent,
    DamShareComponent,
    DamShareSearchElasticComponent,
    ShareDamItemComponent,
    ShareDamItemVersionsComponent,
    ShareDamItemVersionsComponent,
    YandexImportComponent,
  ],
  exports: [
    ShareDamItemComponent,
    ShareDamItemVersionsComponent,
    ShareDamItemVersionsComponent,
    DamShareSearchElasticComponent,
    DamContentComponent,
  ],
  imports: [
    FormlyBootstrapModule,
    FormlyModule,
    FormsModule,
    AdminSharedModule,
    BaseModule,
    BreadcrumbsModule,
    CommonModule,
    DamRoutingModule,
    FileUploadModule,
    MatButtonModule,
    MatMenuModule,
    MatRippleModule,
    MatTreeModule,
    NbActionsModule,
    NbAlertModule,
    NbBadgeModule,
    NbButtonModule,
    NbCardModule,
    NbCheckboxModule,
    NbFormFieldModule,
    NbIconModule,
    NbInputModule,
    NbProgressBarModule,
    NbRadioModule,
    NbSecurityModule,
    NbSelectModule,
    NbSpinnerModule,
    NbTabsetModule,
    NbTagModule,
    NbToggleModule,
    NbTooltipModule,
    NgSelectModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    TableModule,
    TuiNotification,
    CdkDropList,
    CdkDrag,
    SecuredImageComponent,
    CatalogModule
  ]
})
export class DamModule {
}
